import type { PortableTextBlock } from '@portabletext/types';
import { Person } from '../person/personTypes';

export type SanityBlockContent = PortableTextBlock;

export interface Attachment {
  url: string;
  label: string;
}

export interface SanityUrl {
  url: {
    current: string;
  };
}

export enum KeyInfoType {
  email = 'emailAddress',
  link = 'externalLink',
  text = 'freeText',
  person = 'person',
}

export interface KeyInfoTextField {
  _type: KeyInfoType.text;
  title: string;
  value: string;
}

export interface KeyInfoEmailField {
  _type: KeyInfoType.email;
  title: string;
  value: string;
}

export interface KeyInfoLinkField {
  _type: KeyInfoType.link;
  title: string;
  url: string;
}

export interface KeyInfoPersonField extends Person {
  _type: KeyInfoType.person;
}

export type KeyInfoField =
  | KeyInfoTextField
  | KeyInfoEmailField
  | KeyInfoLinkField
  | KeyInfoPersonField;

export interface KeyInfo {
  items?: KeyInfoField[];
}
